"use strict";

var uppercase = require('./uppercase.js');

var lowercase = require('./lowercase.js');

var title = require('./title.js');

var modifiers = [{
  key: 'uppercase',
  transform: uppercase
}, {
  key: 'lowercase',
  transform: lowercase
}, {
  key: 'title',
  transform: title
}];
module.exports = modifiers;